import React from "react";
import { ChronosDate } from "../_helpers";
import { Icon } from "../_components";

export function TimelineNavigation({
  date,
  direction,
  calendar,
  step,
  segmentSize,
  update,
}) {
  const icon =
    direction === "prev" ? "far fa-chevron-left" : "far fa-chevron-right";
  const handleClick = async (ev) => {
    ev.preventDefault();
    // console.group("Timeline Navigation");
    const currentDate = new ChronosDate(date, { calendar });
    // console.log('Handling Navigation ', currentDate, direction, segmentSize);

    // const segment = currentDate.getTimelineSegment(step, {
    //   unitCountDisplay: segmentSize,
    // });
    // console.log('Segment Data', segment);

    if (direction === "next") {
      currentDate.add(segmentSize, step, "1");
      // console.log('CurrentDate', currentDate.asString());

      const nextSegment = currentDate.getTimelineSegment(step, {
        unitCountDisplay: segmentSize,
      });
      // console.log("NEXT SEGMENT", nextSegment);

      const nextPosition = 0;
      // console.groupEnd();

      update(nextSegment.start, nextPosition);
    }
    if (direction === "prev") {
      // console.log("---New Date", currentDate);
      // const newStart = currentDate.subtract(segmentSize, step, "1");
      currentDate.subtract(segmentSize, step, "1");
      // console.log("---New Date", currentDate);

      const nextSegment = currentDate.getTimelineSegment(step, {
        unitCountDisplay: segmentSize,
      });
      // const nextSegment = new ChronosDate(newStart, {
      //   calendar,
      // }).getTimelineSegment(step, {
      //   unitCountDisplay: segmentSize,
      // });
      // console.log("After", nextSegment);

      const nextPosition = segmentSize * 15;
      // console.groupEnd();

      update(nextSegment.start, nextPosition);
    }
  };

  return (
    <div
      className="chronos-timeline-navigation-button"
      onClick={handleClick}
      nav-direction={direction}
    >
      <div className="navigation-button-box">
        <Icon icon={icon} />
      </div>
    </div>
  );
}
